import React from "react";
import {
    Label,
    ListBox,
    ListBoxItem,
    ListBoxItemProps,
    Popover,
    Select,
    SelectProps,
    SelectValue,
    Text,
    composeRenderProps,
} from "react-aria-components";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { Clickable } from "../Clickables";
import { RichText } from "../RichText";
import { Svg } from "../Svg";
import { FieldError, FieldProps } from "./common";

import styles from "./inputs.module.scss";

export function Dropdown<T extends object>({
    label,
    description,
    errorMessage,
    className,
    children,
    ...props
}: Omit<FieldProps, "placeholder" | "label"> & {
    label: string;
} & SelectProps<T>) {
    return (
        <Select
            {...props}
            className={composeRenderProps(className, (cn) =>
                concatClassNames([styles.textField, cn]),
            )}
            isInvalid={!!errorMessage}
            placeholder={label}
        >
            {composeRenderProps(children, (children) => (
                <>
                    {description && (
                        <Text slot="description">
                            <RichText value={description} />
                        </Text>
                    )}
                    <div className={styles.selectWrapper}>
                        <Label className={styles.label}>{label}</Label>
                        <Clickable className={styles.selectButton}>
                            <SelectValue className={styles.selectValue} />
                            <Svg aria-hidden name="caret" />
                        </Clickable>
                    </div>
                    <Popover className={styles.dropdown}>
                        <ListBox className={styles.dropdownItems}>
                            {children}
                        </ListBox>
                    </Popover>
                    <FieldError>{errorMessage}</FieldError>
                </>
            ))}
        </Select>
    );
}

export function DropdownItem({
    children,
    className,
    ...props
}: ListBoxItemProps) {
    return (
        <ListBoxItem
            {...props}
            className={composeRenderProps(className, (cn) =>
                concatClassNames([styles.dropdownItem, cn]),
            )}
        >
            {children}
        </ListBoxItem>
    );
}
